import { createStyles } from '@material-ui/core/styles';
import * as React from 'react';
import { compose } from 'recompose';
import { withBaseProps } from '../../Utils/Component';
const styles = (theme) => createStyles({
    oilSteelBackgroundContainer: {
        display: 'flex',
        flexDirection: 'column',
        overflowY: 'hidden',
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        backgroundColor: theme.color.brand.darkest,
        padding: 0,
        margin: 0,
        position: 'relative',
        zIndex: 100,
        minHeight: '100vh',
    },
    oilSteelLogo: {
        position: 'absolute',
        top: '5%',
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 105,
        width: 350,
    },
});
const OilSteelBackground = (props) => {
    const { classes, children, hideLogo, imagesBaseUrl } = props;
    return (React.createElement("main", { className: classes.oilSteelBackgroundContainer, "data-testid": 'oilandsteel-page' },
        !hideLogo && (React.createElement("img", { alt: 'oilsteel', src: `${imagesBaseUrl}/oilsteel/assets/images/account/oilsteel-logo.svg`, className: classes.oilSteelLogo })),
        children));
};
export default compose(withBaseProps({ styles }))(OilSteelBackground);
//# sourceMappingURL=OilSteelBackground.js.map